<template>
  <div class="index" @scroll="handleScroll">
    <HeaderTop page="home" :isBackgroundShow="isBackgroundShow" :isActive="true" homeTitle="首页"></HeaderTop>
    <div class="banner_index">
      <swiper :options="swiperOption" class="swiper" ref="mySwiper">
        <swiper-slide v-for="(item, index) in bannerList" :key="index">
          <div @mouseenter.stop="mouseenterSwipper" @mouseleave.stop="mouseleaveSwipper" @click="toBannerUrl(item)"
               class="slide">
            <img :src="item.path">
            <div class="searchBtn">
              <transition name="fadeIn">
                <img src="../assets/img/banner_button.png"
                     v-if="item.url!= '' && item.url!=null && swiperIndex == index"/>
              </transition>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="main">
      <div class="main01" ref="main01">
        <div class="title">
          <div class="f_title">PRODUCT AND SERVICES</div>
          <transition name="moveB" v-if="pageWidth > 1280">
            <div class="s_title" v-if="showProduct">产品与服务</div>
          </transition>
          <div class="s_title" v-else>产品中心与服务</div>
        </div>
        <div class="product">
          <div class="left">
            <transition name="fadeIn" v-if="pageWidth >1280">
              <div v-if="showCenter5">
                <img src="../assets/img/p_left_1.png" class="s_c_11" v-if="pageWidth>1280"/>
                <img src="../assets/img/p_left_1_m.png" class="s_c_11" v-else/>
              </div>
            </transition>
            <div v-else>
              <img src="../assets/img/p_left_1.png" class="s_c_11" v-if="pageWidth>1280"/>
              <img src="../assets/img/p_left_1_m.png" class="s_c_11" v-else/>
            </div>
            <transition name="fadeIn" v-if="pageWidth>1280">
              <div class="product_text" v-if="showCenter6" @mouseenter="currentProuductIndex = 1">
                <div :class="currentProuductIndex == 1 ? 'active title':'title'"
                     v-if="productList[0] && productList[0].name">{{
                    productList[0].name.length > 10 ? productList[0].name.substring(0, 10) + '...' : productList[0].name
                  }}
                </div>
                <span :class="currentProuductIndex == 1 ? 'activeInfo_L info_l':'info_l'"
                      v-html="productHtml0.content"></span>
                <transition name="fadeIn"><img src='../assets/img/see_btn.png' v-if="currentProuductIndex == 1"
                                               class="seeNowBtn" @click="toProductDetail(productList[0])"/>
                </transition>
              </div>
            </transition>
            <div class="product_text" v-else @mouseenter="currentProuductIndex = 1" @click="currentProuductIndex = 1">
              <div :class="currentProuductIndex == 1 ? 'active title':'title'"
                   v-if="productList[0] && productList[0].name">{{
                  productList[0].name.length > 10 ? productList[0].name.substring(0, 10) + '...' : productList[0].name
                }}
              </div>
              <span :class="currentProuductIndex == 1 ? 'activeInfo_L info_l':'info_l'"
                    v-html="productHtml0.content"></span>
              <img src='../assets/img/see_btn.png' v-if="currentProuductIndex == 1"
                   class="seeNowBtn" @click="toProductDetail(productList[0])"/>
            </div>
          </div>
          <div class="center" v-if="pageWidth>1280">
            <transition name="fadeIn" v-if="pageWidth>1280">
              <div v-if="showCenter4">
                <img src="../assets/img/s_c_1.png" class="s_c_1"/>
              </div>
            </transition>
            <transition name="fadeIn">
              <img src="../assets/img/circel_01.png" class="circel_01" v-if="showCenter1"/>

            </transition>
            <transition name="fadeIn">
              <img src="../assets/img/circel_02_m.png" class="circel_02" v-if="showCenter2"/>
            </transition>
            <div class="h_line" v-if="isHline">
              <div>
                <transition name="fadeIn"><img src="../assets/img/h_line1.png" class="h_line1"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line2.png" class="h_line2"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line3.png" class="h_line3"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line4.png" class="h_line4"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line5.png" class="h_line5"/></transition>
              </div>
            </div>
            <img src="../assets/img/circel_03.png" class="circel_03" v-if="showCenter3"/>
            <transition name="fadeIn">
              <div v-if="showCenter4">
                <img src="../assets/img/s_c_2.png" class="s_c_2" v-if="pageWidth>1280"/>
                <img src="../assets/img/s_c_2_m.png" class="s_c_2" v-else/>
              </div>
            </transition>
            <transition name="fadeIn">
              <div v-if="showCenter4">
                <img src="../assets/img/s_c_3.png" class="s_c_3" v-if="pageWidth>1280"/>
                <img src="../assets/img/s_c_3_m.png" class="s_c_3" v-else/>
              </div>
            </transition>
          </div>
          <div class="center" v-else>
            <div v-if="showCenter4">
              <img src="../assets/img/s_c_1_m.png" class="s_c_1"/>
            </div>
            <img src="../assets/img/circel_01_m.png" class="circel_01" v-if="showCenter1"/>
            <div>
              <img src="../assets/img/circel_02_m.png" class="circel_02" v-if="showCenter2"/>
            </div>
            <div class="h_line" v-if="isHline">
              <div>
                <transition name="fadeIn"><img src="../assets/img/h_line1.png" class="h_line1"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line2.png" class="h_line2"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line3.png" class="h_line3"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line4.png" class="h_line4"/></transition>
                <transition name="fadeIn"><img src="../assets/img/h_line5.png" class="h_line5"/></transition>
              </div>
            </div>
            <div v-if="pageWidth <= 1280">
              <img src="../assets/img/circel_03_m.png" class="circel_03" v-if="showCenter3"/>
            </div>
            <div>
              <img src="../assets/img/s_c_2.png" class="s_c_2" v-if="pageWidth>1280"/>
              <img src="../assets/img/s_c_2_m.png" class="s_c_2" v-else/>
            </div>
            <div>
              <img src="../assets/img/s_c_3.png" class="s_c_3" v-if="pageWidth>1280"/>
              <img src="../assets/img/s_c_3_m.png" class="s_c_3" v-else/>
            </div>
          </div>
          <div class="right">
            <div class="right_t">
              <transition name="fadeIn">
                <div v-if="showCenter5">
                  <img src="../assets/img/p_right_1.png" class="s_c_12" v-if="pageWidth>1280"/>
                  <img src="../assets/img/p_right_1_m.png" class="s_c_12" v-else/>
                </div>
              </transition>
              <transition name="fadeIn">
                <div class="product_text" v-if="showCenter6" @mouseenter="currentProuductIndex = 2"
                     @click="currentProuductIndex = 2">
                  <div :class="currentProuductIndex == 2 ? 'active title':'title'"
                       v-if="productList[1] && productList[1].name">
                    {{
                      productList[1].name.length > 10 ? productList[1].name.substr(0, 10) + '...' : productList[1].name
                    }}
                  </div>
                  <span :class="currentProuductIndex == 2 ? 'activeinfo info':'info'" class="info"
                        v-html="productHtml1.content"></span>
                  <transition name="fadeIn"><img src='../assets/img/see_btn.png' v-if="currentProuductIndex == 2"
                                                 class="seeNowBtn" @click="toProductDetail(productList[1])"/>
                  </transition>
                </div>
              </transition>
            </div>
            <div class="right_f">
              <transition name="fadeIn">
                <div v-if="showCenter5">
                  <img src="../assets/img/p_right_2.png" class="s_c_13" v-if="pageWidth>1280"/>
                  <img src="../assets/img/p_right_2_m.png" class="s_c_13" v-else/>
                </div>
              </transition>
              <transition name="fadeIn">
                <div class="product_text" v-if="showCenter6" @mouseenter="currentProuductIndex = 3"
                     @click="currentProuductIndex = 3">
                  <div :class="currentProuductIndex == 3 ? 'active title':'title'"
                       v-if="productList[2] && productList[2].name">{{
                      productList[2].name.length > 10 ? productList[2].name.substr(0, 10) + '...' : productList[2].name
                    }}
                  </div>
                  <span class="info" :class="currentProuductIndex == 3 ? 'activeinfo info':'info'"
                        v-html="productHtml2.content"></span>
                  <transition name="fadeIn"><img src='../assets/img/see_btn.png' v-if="currentProuductIndex == 3"
                                                 class="seeNowBtn" @click="toProductDetail(productList[2])"/>
                  </transition>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="main02" ref="main02">
        <div class="title">
          <div class="f_title">ABOUT US</div>
          <transition name="moveB">
            <div class="s_title" v-if="showAboutTitle">关于我们</div>
          </transition>
        </div>
        <div class="aboutus" @click="toAboutUs">
          <transition name="moveL">
            <div v-if="showMap" key="content" class="map">
              <img src="../assets/img/map.png"/>
            </div>
          </transition>
          <div class="aboutInfo">
            <transition name="moveR">
              <div class="info_top" v-if="showAboutInfo">
                {{ this.assistForm.aboutUsInfo }}
              </div>
            </transition>
            <transition name="moveR">
              <div class="info_footer" v-if="showAboutLine">
                <div class="info_footer_l">
                  <div class="img">
                    <transition name="fadeIn">
                      <img src="../assets/img/fwkh.png" v-if="showAboutIcon">
                    </transition>
                  </div>
                  <transition name="fadeIn">
                    <span class="larger_num" v-if="showAboutText">{{ this.assistForm.fwkhValue }}<i>+</i></span>
                  </transition>
                  <transition name="fadeIn">
                    <span class="info" v-if="showAboutText">服务客户</span>
                  </transition>
                </div>
                <div class="info_footer_r">
                  <div class="img">
                    <transition name="fadeIn">
                      <img src="../assets/img/rzzl.png" v-if="showAboutIcon">
                    </transition>
                  </div>
                  <transition name="fadeIn">
                    <span class="larger_num" v-if="showAboutText">{{ this.assistForm.rzzlValue }}<i>+</i></span>
                  </transition>
                  <transition name="fadeIn">
                    <span class="info" v-if="showAboutText">软著专利资质</span>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="main03" ref="main03">
        <div class="title">
          <div class="f_title">DYNAMIC INFORMATION</div>
          <transition name="moveB">
            <div class="s_title" v-if="showNewsTitle">资讯动态</div>
          </transition>
        </div>
        <div class="information">
          <div class="information_l">
            <div class="infor_s_title">
              <transition name="moveL">
                <span class="s_t" v-if="showNewsSencondTitle">企业资讯</span>
              </transition>
              <span class="more" @click="toInformationDynamics('10','2', '7')">
                <transition name="moveB">
                  <img src="../assets/img/inComming.png" v-if="showNewsMore"/>
                </transition>
              </span>
            </div>
            <div class="information_l_list" v-for="(list, index) in newList" :key="index"
                 @mouseenter="handleMouseEnterNews(index)" @click="toInformationDynamicsDetai(list)">
              <div :class="currentNewsIndex == index ? 'active list_title': 'list_title'"><i>•</i>{{ list.title }}</div>
              <div :class="currentNewsIndex == index ? 'activeInfo list_info' : 'list_info'"
              >{{ list.outline }}
              </div>
            </div>
          </div>
          <div class="information_r">
            <div class="infor_s_title">
              <transition name="moveR">
                <span class="s_t" v-if="showNewsSencondTitle">行业资讯</span>
              </transition>
              <span class="more" @click="toInformationDynamics('10','2','8')">
                <transition name="moveB"><img src="../assets/img/inComming.png" v-if="showNewsMore"/></transition>
              </span>
            </div>
            <div class="information_l_list" v-for="(list, index) in hyNewList" :key="index"
                 @mouseenter="handleMouseEnterHy(index)" @click="toInformationDynamicsDetai(list)">
              <div :class="currentHyIndex == index ? 'active list_title': 'list_title'"><i>•</i><span>{{
                  list.title
                }}</span></div>
              <div :class="currentNewsIndex == index ? 'activeInfo list_info' : 'list_info'" v-if="pageWidth <= 1280"
              >{{ list.outline }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main04" ref="main04">
        <div class="title" v-if="pageWidth <= 1280">
          <div class="f_title">TECHNICAL SUPPORT</div>
          <transition name="moveB">
            <div class="s_title" v-if="showNewsTitle">技术支持</div>
          </transition>
        </div>
        <div class="info04">
          <div class="list_title">
            <div class="list_title_l">
              <img src="../assets/img/jszc_on.png" v-if="technolgyIcon1"/>
              <div v-else class="emptyImg"></div>
              <transition name="fadeIn"><span v-if="technolgyThree1" @click="toTochnolgy('1')"
                                              :class="technolgyIcon1?'active':''">{{ jszcMenu[0].name }}<i
                v-if="technolgyIcon1 && pageWidth >1280"></i></span></transition>
            </div>
            <div class="list_title_l">
              <img src="../assets/img/jszc_on.png" v-if="technolgyIcon2"/>
              <div v-else class="emptyImg"></div>
              <transition name="fadeIn"><span v-if="technolgyThree2" @click="toTochnolgy('2',jszcMenu[1].id)"
                                              :class="technolgyIcon2?'active':''">{{ jszcMenu[1].name }}<i
                v-if="technolgyIcon2 && pageWidth >1280"></i></span></transition>
            </div>
            <div class="list_title_l">
              <img src="../assets/img/jszc_on.png" v-if="technolgyIcon3"/>
              <div v-else class="emptyImg"></div>
              <transition name="fadeIn"><span v-if="technolgyThree3" @click="toTochnolgy('3', jszcMenu[2].id)"
                                              :class="technolgyIcon3?'active':''">{{ jszcMenu[2].name }}<i
                v-if="technolgyIcon3 && pageWidth >1280"></i></span></transition>
            </div>
            <transition name="moveR" v-if="pageWidth >1280">
              <div class="title" v-if="technolgyTwo">TECHNICAL </br> SUPPORT</div>
            </transition>
          </div>
          <div class="image">
            <transition name="moveB" v-if="pageWidth >1280">
              <div class="i_title" v-if="technolgyTwo">技术支持</div>
            </transition>
            <transition name="fadeIn">
              <img src="../assets/img/jszc_bg.png" v-if="technolgyOne"/>
            </transition>
          </div>
          <transition name="fadeIn">
            <div v-if="technolgyFour" class="info_r">
              <div class="info" v-if="shlxShow">
                <transition name="fadeIn">
                  <div class="info_l" v-if="technolgyFive">
                    <div class="info_l_t">电话支持</div>
                    <div class="info_l_c">
                      <span v-if="this.assistForm.phoneZc.length >20">{{
                          this.assistForm.phoneZc.substring(0, 20) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.phoneZc }}</span>
                    </div>
                    <div class="info_l_r">
                      <span v-if="this.assistForm.phoneZcTime.length >30">{{
                          this.assistForm.phoneZcTime.substring(0, 30) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.phoneZcTime }}</span>
                    </div>
                  </div>
                </transition>
                <transition name="fadeIn">
                  <div class="info_l" v-if="technolgyFive">
                    <div class="info_l_t">E-mail支持</div>
                    <div class="info_l_c">
                      <span v-if="this.assistForm.emailZc.length >20">{{
                          this.assistForm.emailZc.substring(0, 20) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.emailZc }}</span>
                    </div>
                    <div class="info_l_r">
                      <span v-if="this.assistForm.emailZcTime.length >30">{{
                          this.assistForm.emailZcTime.substring(0, 30) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.emailZcTime }}</span>
                    </div>
                  </div>
                </transition>
                <transition name="fadeIn">
                  <div class="info_l" v-if="technolgyFive">
                    <div class="info_l_t">远程支持</div>
                    <div class="info_l_r">
                      <span v-if="this.assistForm.remoteZcTime.length >50">{{
                          this.assistForm.remoteZcTime.substring(0, 50) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.remoteZcTime }}</span>
                    </div>
                  </div>
                </transition>
                <transition name="fadeIn">
                  <div class="info_l" v-if="technolgyFive">
                    <div class="info_l_t">现场支持</div>
                    <div class="info_l_r">
                      <span v-if="this.assistForm.xcZc.length >30">{{
                          this.assistForm.xcZc.substring(0, 30) + '...'
                        }}</span>
                      <span v-else>{{ this.assistForm.xcZc }}</span>
                    </div>
                  </div>
                </transition>
              </div>
              <div class="info" v-if="questionShow">
                <div class="question" v-html="questionInfoHtml.content"></div>
              </div>
              <div class="info" v-if="xtczShow">
                <div class="question" v-html="xtczInfoHtml.content"></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="main05">
        <div class="title">
          <div class="f_title">COOPERATIVE PARTNER</div>
          <div class="s_title">合作伙伴</div>
        </div>
        <div class="scroll_list">
          <div class="scroll_list_bg"></div>
          <div class="scroll_list_info">
            <div class="partner_list" v-for="(item, index) in partnerList" :key="index" @click="clickFirstMenu">
              <vue-seamless-scroll :data="item.imgList" :class-option="isOddRow(index)?optionRight:optionLeft"
                                   class="seamless-warp2">
                <ul class="item">
                  <li v-for="(list, listIndex) in item.imgList" :key="listIndex" @click="toLink(list)">
                    <img :src="list.picpath"/>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
      <div class="main06">
        <div class="title">
          <div class="f_title">TYPICAL USERS</div>
          <div class="s_title">典型用户</div>
        </div>
        <div class="partner_list" v-for="(item, index) in userList" :key="index" @click="clickFirstMenu">
          <vue-seamless-scroll :data="item.imgList" :class-option="isOddRow(index)?optionRight:optionLeft"
                               class="seamless-warp2">
            <ul class="item">
              <li v-for="(list, listIndex) in item.imgList" :key="listIndex" @click="toLink(list)">
                <img :src="list.picpath"/>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_o">
        <div class="bottom_logo">
          <img src="../assets/img/logo.png"/>
        </div>
        <div class="tel">
          <img src="../assets/img/tel@2x.png"/>
          <span>{{ this.assistForm.phone }}</span>
        </div>
        <div class="email">
          <img src="../assets/img/email@2x.png"/>
          <span>{{ this.assistForm.email }}</span>
        </div>
        <div class="ewm">
          <img :src="ewmImg"/>
        </div>
      </div>
      <div class="bottom_t">
        <img src="../assets/img/beian.png"/>
        <span @click="toGa">陕公网安备61019002001202号<i v-if="pageWidth > 1280">|</i></span>
        <span @click="toICP">陕ICP备20012057号<i>|</i></span>
        <span class="copyright">Copyright @ 2024 西安灵软信息技术有限公司</span>
      </div>
    </div>
    <float-element :showTop="showTop" :isActive="true"></float-element>
  </div>
</template>

<script>
import HeaderTop from "@/components/headerTop";
import Bottom from "@/components/bottom";
import Menus from "@/components/menus";
import "../assets/css/index.less";
import FloatElement from "@/components/floatElement";
import {_getArticleList, _getauxiliaryinfo, _getBannerImgList} from "../api/services/InterfaceConfigurationPage";

export default {
  name: "index",
  components: {
    HeaderTop,
    Menus,
    Bottom,
    FloatElement
  },
  data() {
    return {
      jszcMenu: [],
      swiperIndex: -1,
      pageWidth: 0,
      isHline: false,
      productHtml0: {},
      productHtml1: {},
      productHtml2: {},
      shlxShow: true,
      questionShow: false,
      xtczShow: false,
      isBackgroundShow: false, // 顶部菜单是否添加背景
      showTop: false, // 返回顶部
      zxdhShow: false,
      isQQshow: false,
      hzhbHeight: 0,
      hzhbHeightInfo: 0,
      showProduct: false,
      currentProuductIndex: 0,
      showCenter1: false,
      showCenter2: false,
      showCenter3: false,
      showCenter4: false,
      showCenter5: false,
      showCenter6: false,
      currentNewsIndex: -1,
      currentHyIndex: -1,
      showMap: false,
      showAboutTitle: false,
      showAboutInfo: false,
      showAboutLine: false,
      showAboutIcon: false,
      showAboutText: false,
      showNewsTitle: false,
      showNewsMore: false,
      showNewsSencondTitle: false,
      technolgyOne: false,
      technolgyTwo: false,
      technolgyThree: false,
      technolgyThree1: false,
      technolgyThree2: false,
      technolgyThree3: false,
      technolgyFour: false,
      technolgyFive: false,
      technolgyIcon3: false,
      technolgyIcon1: false,
      technolgyIcon2: false,
      productList: [],
      currentMenuIndex: -1,
      inputSearch: false,
      menuList: [],
      hyNewList: [],
      newList: [],
      swiperOption: {
        //组件不会通过NextTick来实例化swiper，即第一时间获取到swiper对象
        notNextTick: true,
        //通过插槽slot使用分页器
        // prevButton: '.swiper-button-prev',
        // nextButton: '.swiper-button-next',
        //实现轮播图循环
        loop: true,
        //实现轮播图自动滚动
        autoplay: true,
        //设置滚动速度
        speed: 3000,
        //解决小圆点渲染失败问题
        pagination: {
          el: '.swiper-pagination',
          // 点击小圆点实现切换
          clickable: true,

        },
        // zoom: true,
        // 手机端双击放大
        // grabCursor:true,
        // 手型
      },
      userList: [],
      bannerList: [],
      partnerList: [],
      assistForm: {
        phone: '',
        email: '',
        zxPhone: '',
        qq: '',
        fwkhValue: '',
        rzzlValue: '',
        phoneZc: '',
        phoneZcTime: '',
        emailZc: '',
        emailZcTime: '',
        remoteZcTime: '',
        xcZc: '',
        aboutUsInfo: ''
      },
      ewmImg: '',
      xtczInfoHtml: {},
      questionInfoHtml: {}
    };
  },
  computed: {
    optionLeft() {
      return {
        direction: 2, // 向左滚动
        limitMoveNum: this.pageWidth > 1280 ? 5 : 3,
        openWatch: true, // 开启数据实时监控刷新dom
      }
    },
    optionRight() {
      return {
        direction: 3, // 向右滚动
        limitMoveNum: this.pageWidth > 1280 ? 5 : 3,
        openWatch: true, // 开启数据实时监控刷新dom
      }
    },
    isOddRow() {
      return function (index) {
        return index % 2 === 0; // 返回true表示偶数行，false表示奇数行
      };
    }
  },
  watch: {},
  created() {
    this.getBannerImgList()
  },
  mounted: function () {
    this.pageWidth = document.documentElement.clientWidth
    // 移动端不滚动
    if (this.pageWidth <= 1280) {
      this.showProduct = true
      this.showCenter1 = true
      this.showCenter2 = true
      // this.showCenter3 = true
      this.showCenter4 = true
      this.showCenter5 = true
      this.showCenter6 = true
      this.showAboutTitle = true
      this.showMap = true;
      this.isHline = true
      this.showAboutInfo = true
      this.showAboutLine = true
      this.showAboutText = true
      this.showAboutIcon = true
      this.showNewsTitle = true
      this.showNewsSencondTitle = true
      this.showNewsMore = true
      this.technolgyOne = true
      this.technolgyTwo = true
      this.technolgyThree1 = true
      this.technolgyIcon1 = true
      this.technolgyThree2 = true
      this.technolgyThree3 = true
      this.technolgyFour = true
      this.technolgyFive = true
    }
    // this.$Message.info('页面宽度==', this.pageWidth)
    //可用于设置自适应屏幕，根据获得的可视宽度（兼容性）判断是否显示
    let w = document.documentElement.offsetWidth || document.body.offsetWidth;
    if (w < 1000) {
      this.show = false;
    }
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    // 计算合作伙伴滚动区高度
    // this.hzhbHeight = this.$refs.hzhb.offsetHeight; // 获取<div>的高度
    // this.hzhbHeightInfo = -this.hzhbHeight + 'px'
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  },
  methods: {
    // 点击合作伙伴和典型用户
    clickFirstMenu() {
      // 获取二级菜单
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 2,
          firstlevelid: 4
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.secondMenuList = []
          } else {
            var n = 0
            if (res.data.length > 0) {
              res.data.forEach((otm, index) => {
                if (otm.type != 1 && n == 0) {
                  this.toDetail(otm)
                  n++
                }
              })
            }
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },

    // 点击二级菜单
    toDetail(menu, index) {
      // 1 文章模式、2产品模式、 3 新闻模式
      if (menu.pagemodel == 1) {
        // this.getJszcList(menu.id)
        this.$router.push({
          path: '/companyIntro',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
      if (menu.pagemodel == 2) {
        this.$router.push({
          path: '/productCenter',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
      if (menu.pagemodel == 3) {
        this.$router.push({
          path: '/InformationDynamics',
          query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
        })
      }
    },
    // ICP备案
    toICP() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    },
    // 公安备案
    toGa() {
      window.open('https://beian.mps.gov.cn/#/query/webSearch', '_blank')
    },
    mouseleaveSwipper() {
      this.swiperIndex = -1
      this.$forceUpdate()
    },
    mouseenterSwipper() {
      this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex
      this.$forceUpdate()
    },
    getHzhbList() {
      this.$API.InterfaceConfigurationPage._getArticleList({
        params: {
          secondlevelid: 1015,
          pagesize: 500,
          pageindex: 1
        }
      }).then(res => {
        if (res.success) {
          var newArry = []
          if (res.data.length > 0) {
            var partnerList = []
            if (this.pageWidth > 1280) {
              partnerList = this.group(res.data, 5)
            } else {
              partnerList = this.group(res.data, 3)
            }
            partnerList.forEach(item => {
              var obj = {
                imgList: item
              }
              newArry.push(obj)
            })
          }
          this.partnerList = newArry
          this.getUserList() // 典型用户
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取典型用户
    getUserList() {
      this.$API.InterfaceConfigurationPage._getArticleList({
        params: {
          secondlevelid: 1016,
          pagesize: 500,
          pageindex: 1
        }
      }).then(res => {
        if (res.success) {
          var newArry = []
          if (res.data.length > 0) {
            var partnerList = []
            if (this.pageWidth > 1280) {
              partnerList = this.group(res.data, 5)
            } else {
              partnerList = this.group(res.data, 3)
            }
            partnerList.forEach(item => {
              var obj = {
                imgList: item
              }
              newArry.push(obj)
            })
          }
          this.userList = newArry
          this.getauxiliaryinfo() // 获取辅助参数
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 重构数组
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      // if(array.length > 5) {
      newArray.map((item, index) => {
        if (item.length < subGroupLength) {
          newArray[index] = newArray[index].concat(array.slice(0, subGroupLength - newArray[index].length))
        }
      })
      // }
      if (newArray.filter(item => item.length < subGroupLength).length > 0) {
        newArray.map((item, index) => {
          if (item.length < subGroupLength) {
            newArray[index] = newArray[index].concat(newArray[index].slice(0, subGroupLength - newArray[index].length))
          }
        })
      }
      return newArray;
    },
    // 获取行业动态列表
    getHyxtList() {
      this.$API.InterfaceConfigurationPage._getArticleList({
        params: {
          secondlevelid: 8,
          pagesize: 5,
          pageindex: 1
        }
      }).then(res => {
        if (res.success) {
          this.hyNewList = res.data
          // 获取技术支持二级菜单
          this.getJSZCList()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    //
    getJSZCList() {
      // 获取二级菜单
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 2,
          firstlevelid: 3
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.jszcMenu = []
          } else {
            this.jszcMenu = res.data
          }
          this.getHzhbList() //合作伙伴
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取动态资讯列表
    getDtzxList() {
      this.$API.InterfaceConfigurationPage._getArticleList({
        params: {
          secondlevelid: 7,
          pagesize: 5,
          pageindex: 1
        }
      }).then(res => {
        if (res.success) {
          this.newList = res.data
          this.getHyxtList()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取辅助参数
    getauxiliaryinfo() {
      this.$API.InterfaceConfigurationPage._getauxiliaryinfo().then(res => {
        if (res.success) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              if (item.name == '电话') {
                this.assistForm.phone = item.value
              }
              if (item.name == '邮箱') {
                this.assistForm.email = item.value
              }
              if (item.name == '咨询电话') {
                this.assistForm.zxPhone = item.value
              }
              if (item.name == 'WeChat') {
                this.assistForm.qq = item.value
              }
              if (item.name == '服务客户') {
                this.assistForm.fwkhValue = item.value
              }
              if (item.name == '软著专利资质') {
                this.assistForm.rzzlValue = item.value
              }
              if (item.name == '电话支持') {
                this.assistForm.phoneZc = item.value
              }
              if (item.name == '电话支持时间') {
                this.assistForm.phoneZcTime = item.value
              }
              if (item.name == 'E-mail支持') {
                this.assistForm.emailZc = item.value
              }
              if (item.name == 'E-mail支持时间') {
                this.assistForm.emailZcTime = item.value
              }
              if (item.name == '远程支持时间') {
                this.assistForm.remoteZcTime = item.value
              }
              if (item.name == '现场支持') {
                this.assistForm.xcZc = item.value
              }
              if (item.name == '关于我们') {
                this.assistForm.aboutUsInfo = item.value
              }
            })
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 产品列表展示
    getProductList() {
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 2,
          firstlevelid: 2
        }
      }).then(res => {
        if (res.success) {
          this.productList = res.data
          res.data.forEach((item, index) => {
            if (index < 3) {
              this.getProductDataList(index)
            }
          })
          this.getDtzxList()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 产品中心列表
    getProductDataList(index) {
      this.$API.InterfaceConfigurationPage._getArticleList({
        params: {
          secondlevelid: this.productList[index].id,
          pagesize: 3,
          pageindex: 1,
          homepage: true
        }
      }).then(res => {
        if (res.success) {
          if (res.data[0].id) {
            this.$API.InterfaceConfigurationPage._getArticleDetail({
              params: {
                id: res.data[0].id
              }
            }).then(res => {
              if (res.success) {
                if (index == 0) {
                  this.productHtml0 = res.data
                }
                if (index == 1) {
                  this.productHtml1 = res.data
                }
                if (index == 2) {
                  this.productHtml2 = res.data
                }
              } else {
                this.$Message.info('系统错误')
              }
            }).catch(err => {
              console.log('获取失败===', err);
            });
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 产品详情跳转
    toProductDetail(menu) {
      this.$router.push({
        path: '/productCenter',
        query: {parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath}
      })
    },
    // banner图跳转
    toBannerUrl(item) {
      if (item.url != '' && item.url != null && item.url != undefined) {
        window.open(item.url, '_blank')
      }
    },
    //
    toLink(item) {
      if (item.url != '' && item.url != null && item.url != undefined) {
        window.open(item.url, '_blank')
      }
    },
    // banner图及二维码
    getBannerImgList() {
      this.$API.InterfaceConfigurationPage._getBannerImgList({
        params: {
          type: 1
        }
      }).then(res => {
        if (res.success) {
          this.bannerList = res.data.slice(0, 5)
          this.getBannerQrCode()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取二维码
    getBannerQrCode() {
      this.$API.InterfaceConfigurationPage._getBannerImgList({
        params: {
          type: 2
        }
      }).then(res => {
        if (res.success) {
          this.ewmImg = res.data[0].path
          this.getProductList()
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 资讯动态详情
    toInformationDynamicsDetai(list) {
      this.$router.push({path: '/InformationDynamicsDetail', query: {id: list.id}})
    },
    // 资讯动态更多
    toInformationDynamics(parentid, grade, id) {
      this.$router.push({path: '/InformationDynamics', query: {parentid: parentid, id: id, grade: grade}})
    },
    // 关于我们
    toAboutUs() {
      this.$router.push({
        path: '/companyIntro', query: {
          parentid: 1,
          id: 1,
          grade: 2
        }
      })
    },
    // 留言板
    toMessageBoard() {
      this.$router.push({path: '/messageBoard'})
    },
    // 咨询电话
    toShowZxdh() {
      this.zxdhShow = !this.zxdhShow
      this.isQQshow = false
    },
    // QQ
    toShowQQ() {
      this.isQQshow = !this.isQQshow
      this.zxdhShow = false
    },
    // 回到顶部
    goTop() {
      // 使用 window.scrollTo 将页面滚动位置设为顶部
      window.scrollTo(0, 0);
    },
    // 滚动
    handleScroll(event) {
      const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
      // 产品中心
      if (scrollTop >= 10) {
        this.showTop = true
      } else {
        this.showTop = false
      }
      if (scrollTop >= 100) {
        this.isBackgroundShow = true
      } else {
        this.isBackgroundShow = false
      }
      if (this.pageWidth > 1280) {
        if (0 <= this.$refs.main01.offsetTop - scrollTop <= window.innerHeight) {
          this.showProduct = true
        }
        if (this.$refs.main01.getBoundingClientRect().top + this.$refs.main01.getBoundingClientRect().height * 0.7 <= window.innerHeight && this.$refs.main01.getBoundingClientRect().bottom >= 0) {
          this.showCenter1 = true
          setTimeout(() => {
            this.showCenter2 = true
          }, 800)
          setTimeout(() => {
            if (this.isHline) {
              this.showCenter3 = false
            } else {
              this.showCenter3 = true
            }
          }, 1600)
          setTimeout(() => {
            this.showCenter4 = true
          }, 2400)
          setTimeout(() => {
            this.showCenter5 = true
          }, 3200)
          setTimeout(() => {
            this.showCenter6 = true
          }, 4000)
          setTimeout(() => {
            this.showCenter3 = false
            this.isHline = true
          }, 4500)
        }
        // if (this.$refs.main01.getBoundingClientRect().top + this.$refs.main01.getBoundingClientRect().height * 0.95 <= window.innerHeight && this.$refs.main01.getBoundingClientRect().bottom >= 0) {
        //   this.showCenter3 = false
        //   this.isHline = true
        // }
        // if (this.$refs.main02.getBoundingClientRect().top + this.$refs.main02.getBoundingClientRect().height <= window.innerHeight && this.$refs.main02.getBoundingClientRect().bottom >= 0) {
        //   this.showCenter3 = false
        //   this.isHline = true
        // }
        if (this.$refs.main02.getBoundingClientRect().top + this.$refs.main02.getBoundingClientRect().height * 0.3 <= window.innerHeight && this.$refs.main02.getBoundingClientRect().bottom >= 0) {
          this.showAboutTitle = true
        }
        if (this.$refs.main02.getBoundingClientRect().top + this.$refs.main02.getBoundingClientRect().height * 0.7 <= window.innerHeight && this.$refs.main02.getBoundingClientRect().bottom >= 0) {
          this.showMap = true; // 在合适的时机改变变量值，地图出现
          setTimeout(() => {
            this.showAboutInfo = true
            this.showAboutLine = true
          }, 800)
          setTimeout(() => {
            this.showAboutText = true
          }, 1600)
          setTimeout(() => {
            this.showAboutIcon = true
          }, 2400)
        }
        if (this.$refs.main03.getBoundingClientRect().top + this.$refs.main03.getBoundingClientRect().height * 0.3 <= window.innerHeight && this.$refs.main03.getBoundingClientRect().bottom >= 0) {
          // 新闻资讯标题展示
          this.showNewsTitle = true
        }
        if (this.$refs.main03.getBoundingClientRect().top + this.$refs.main03.getBoundingClientRect().height * 0.7 <= window.innerHeight && this.$refs.main03.getBoundingClientRect().bottom >= 0) {
          // 二级标题显示
          this.showNewsSencondTitle = true
          setTimeout(() => {
            this.showNewsMore = true
          }, 800)
        }
        if (this.$refs.main04.getBoundingClientRect().top + this.$refs.main04.getBoundingClientRect().height * 0.3 <= window.innerHeight && this.$refs.main04.getBoundingClientRect().bottom >= 0) {
          this.technolgyOne = true
          setTimeout(() => {
            this.technolgyTwo = true
          }, 800)
          setTimeout(() => {
            this.technolgyThree1 = true
            this.technolgyIcon1 = true
          }, 1600)
          setTimeout(() => {
            this.technolgyThree2 = true
          }, 2400)
          setTimeout(() => {
            this.technolgyThree3 = true
          }, 3200)
          setTimeout(() => {
            this.technolgyFour = true
          }, 4000)
          setTimeout(() => {
            this.technolgyFive = true
          }, 4800)
        }
      } else {
        this.showProduct = true
        this.showCenter1 = true
        this.showCenter2 = true
        this.isHline = true
        this.showCenter4 = true
        this.showCenter5 = true
        this.showCenter6 = true
        this.showAboutTitle = true
        this.showMap = true;
        this.showAboutInfo = true
        this.showAboutLine = true
        this.showAboutText = true
        this.showAboutIcon = true
        this.showNewsTitle = true
        this.showNewsSencondTitle = true
        this.showNewsMore = true
        this.technolgyOne = true
        this.technolgyTwo = true
        this.technolgyThree1 = true
        this.technolgyIcon1 = true
        this.technolgyThree2 = true
        this.technolgyThree3 = true
        this.technolgyFour = true
        this.technolgyFive = true
      }
    },
    // 点击技术支持小标题
    toTochnolgy(num, id) {
      if (num == '1') {
        this.technolgyIcon1 = true
        this.technolgyIcon2 = false
        this.technolgyIcon3 = false
        this.shlxShow = true // 售后联系方式
        this.questionShow = false
        this.xtczShow = false
      }
      if (num == '2') {
        // 常见问题 secodeMenuId:1013
        this.technolgyIcon2 = true
        this.technolgyIcon1 = false
        this.technolgyIcon3 = false
        this.technolgyFour = false
        this.shlxShow = false // 售后联系方式
        this.questionShow = true
        this.xtczShow = false
        this.technolgyFour = true
        this.getJszcList(num, id)
      }
      if (num == '3') {
        // 系统操作适配 secodeMenuId:1014
        this.technolgyIcon3 = true
        this.technolgyIcon2 = false
        this.technolgyIcon1 = false
        this.shlxShow = false  // 售后联系方式
        this.xtczShow = true
        this.questionShow = false
        this.technolgyFour = false
        this.getJszcList(num, id)
        this.technolgyFour = true
      }
    },
    // 获取技术支持列表
    getJszcList(num, id) {
      var params = {
        secondlevelid: id,
        pagesize: 5,
        pageindex: 1
      }
      this.$API.InterfaceConfigurationPage._getArticleList({
        params
      }).then(res => {
        if (res.success) {
          this.getJszcDetail(res.data[0].id, num)
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取技术支持内容
    getJszcDetail(id, num) {
      this.$API.InterfaceConfigurationPage._getArticleDetail({
        params: {
          id: id
        }
      }).then(res => {
        if (res.success) {
          if (num == 2) {
            this.questionInfoHtml = res.data
          } else if (num == 3) {
            this.xtczInfoHtml = res.data
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 新闻鼠标移入效果
    handleMouseEnterNews(index) {
      this.currentNewsIndex = index
      this.$forceUpdate()
    },
    // 行业动态鼠标移入效果
    handleMouseEnterHy(index) {
      this.currentHyIndex = index
      this.$forceUpdate()
    }
  }
};

</script>
<style>
@media screen and (max-width: 1280px) {
  .main04 .info04 .info .question {
    font-family: Microsoft YaHei !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    color: rgba(255, 255, 255, .5) !important;
  }
}

// PC 端
@media screen and (min-width: 1281px) {
  .main04 .info04 .info .question {
    font-family: Microsoft YaHei !important;
    font-weight: 400 !important;
    font-size: 18px !important;
    color: rgba(255, 255, 255, .5) !important;
  }
}
</style>

<style scoped lang="less">
@import "../assets/css/header.less";
@import "../assets/css/index.less";
</style>



// WEBPACK FOOTER //
// src/views/index.vue